import { FailedToGetData, H2, Loading } from 'src/components/_commons';
import { FC, useEffect, useState } from 'react';
import { HTHInteractiveMapFamilies } from './HTHInteractiveMapFamilies';
import { HTHInteractiveMapMap } from './HTHInteractiveMapMap';
import { HTHInteractiveMapS13 } from './HTHInteractiveMapS13';
import { HTHInteractiveMapToast } from './HTHInteractiveMapToast';
import { mapServices, publicMinistryServices } from 'src/services';
import { setAlertResponse } from 'src/store';
import { typeHTHTerritory, typeMapDoc, typeMapToast, typePublicMinistryDoc } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode, useTerritoryDates } from 'src/custom-hooks';

type propsType = {
    hthTerritories: typeHTHTerritory[];
};

// not being used

export const HTHInteractiveMap: FC<propsType> = ({ hthTerritories }) => {
    const [isLoading1, setIsLoading1] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [mapDoc, setMapDoc] = useState<typeMapDoc | null>(null);
    const [publicMinistryDoc, setPublicMinistryDoc] = useState<typePublicMinistryDoc | null>(null);
    const [toast, setToast] = useState<typeMapToast | null>(null);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    
    const { territoryDates, loading, error, handleFile } = useTerritoryDates();

    useEffect(() => {
        mapServices.Get().then(response => {
            setIsLoading1(false);
            if (!response.success || !response.data?.mapDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setMapDoc(response.data.mapDoc);
        });
    }, []);

    useEffect(() => {
        publicMinistryServices.Get().then(response => {
            setIsLoading2(false);
            if (!response.success || !response.data?.publicMinistryDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setPublicMinistryDoc(response.data.publicMinistryDoc);
        });
    }, []);

    if (isLoading1 || isLoading2) {
        return <Loading mt={'80px'} />;
    }

    if (!mapDoc || !publicMinistryDoc) {
        return <FailedToGetData />;
    }

    return (
        <div className={`container ${isDarkMode ? 'text-white' : ''} mt-5`}>
            <H2 title={'MAPA DE TERRITORIOS'} />
            <HTHInteractiveMapToast
                setToast={setToast}
                toast={toast}
            />
            <HTHInteractiveMapMap
                hthTerritories={hthTerritories}
                mapDoc={mapDoc}
                publicMinistryDoc={publicMinistryDoc}
                setToast={setToast}
                territoryDates={territoryDates}
            />
            <HTHInteractiveMapS13
                errorDates={error}
                handleFile={handleFile}
                loadingDates={loading}
            />
            <HTHInteractiveMapFamilies
                mapDoc={mapDoc}
                setToast={setToast}
            />
        </div>
    );
}
